import OrderDetails from './components/orderDetails';
import {OrderProvider} from './providers/orderDetailsProvider';

function OrderDetailsPage() {
  return (
    <OrderProvider>
      <OrderDetails />
    </OrderProvider>
  );
}

export default OrderDetailsPage;
